import FormWithProvider from 'components/forms/form/Form';
import LoadingPlaceholder from 'components/loader/LoadingPlaceholder';
import { GetIntegrationAgencySettingsResponseTO } from 'models/InternalIntegrationSetting';
import { LockAssignmentSwitchContainerStyled } from './LockAssignmentSelect.styles';
import LockSelect from './LockSelect';
import useLockAssignment from './useLockAssignment';

const LockAssignmentSelect = ({
  integrationAgencySettings,
  propertyUid,
  propertyName,
  pagePropertyUids,
}: {
  integrationAgencySettings: GetIntegrationAgencySettingsResponseTO;
  propertyUid: string;
  propertyName: string;
  pagePropertyUids: string[];
}) => {
  const {
    lockOptions,
    currentLockId,
    isLoading: isLoadingLockAssignment,
  } = useLockAssignment({
    integrationAgencySettings,
    propertyUid,
    pagePropertyUids,
  });

  const integrationName =
    integrationAgencySettings.integration?.displayName ??
    integrationAgencySettings.integration?.name;

  if (isLoadingLockAssignment) {
    return (
      <LockAssignmentSwitchContainerStyled>
        <LoadingPlaceholder width="225px" linesCount={1.5} />
      </LockAssignmentSwitchContainerStyled>
    );
  }

  return (
    <LockAssignmentSwitchContainerStyled>
      <FormWithProvider
        defaultValues={{ lockId: currentLockId }}
        // the request dispatch is handled by the onChangeHandler, since we don't have a submit button
        onSubmit={() => {}}
      >
        <LockSelect
          integrationName={integrationName}
          options={lockOptions}
          integrationAgencySettings={integrationAgencySettings}
          propertyUid={propertyUid}
          propertyName={propertyName}
        />
      </FormWithProvider>
    </LockAssignmentSwitchContainerStyled>
  );
};

export default LockAssignmentSelect;
